export default __webpack_public_path__ + "static/media/logo_doopage_white.efd40329.png";